// extracted by mini-css-extract-plugin
export default {"container":"TableLoading_container__Ous47","hideBorder":"TableLoading_hideBorder__x+SN3","color":"TableLoading_color__BEiKN"};